export const TextTeaserWidgetId = 'TextTeaserWidget';

export enum TextTeaserWidgetAttributes {
  LINK = 'link',
  SUBJECT = 'subject',
  IMAGE = 'image',
  IMAGE_ALT = 'imageAltText',
  IMAGE_TITLE = 'imageTitle',
}
